import { Component, createRef } from "react";
import { connect } from "react-redux";
import moment from "moment-jalaali";
import config from "../../../../utils/config";
import { secondsToTime } from "../../../../utils";
import Card from "../../../../components/card";
import { Warning } from "../../../../components/button";
import Detail from "../Detail";
import ChangeStatus from "../changeStatus";
import {
  Div,
  Container,
  LogoContainer,
  Logo,
  Title,
  ItemData,
  BorderLine,
  Icon,
  IconLine,
  Timer,
  OrderStatus,
} from "./style";

import logoImg from "../../../../assets/images/64.png";

var timer = false;

class Item extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderStatus: false,
      timer: this.props?.data?.prepare_at_second
        ? this.props?.data?.prepare_at_second
        : 0,
    };
  }

  componentDidMount = () => {
    if (this.props?.data?.prepare_at && this.props?.data?.status !== 3) {
      timer = setInterval(() => {
        if (this.state.timer > 0) {
          this.setState({ timer: this.state.timer - 1, orderStatus: false });
        } else {
          clearInterval(timer);

          this.setState({ orderStatus: true });
        }
      }, 1000);
    }
  };

  render() {
    const orderDetailRef = createRef();

    const { data, theme } = this.props;

    return (
      <>
        <Detail refrence={orderDetailRef} data={data} />
        <Container>
          <Card className="p-2 py-3 text-right mb-2">
            <Div>
              <LogoContainer className="d-inline-block" theme={theme}>
                <Logo src={logoImg} />
              </LogoContainer>
              <Div className="d-inline-block vertical-align-middle mr-3">
                <Title className="f-15" theme={theme}>
                  {config.description}
                </Title>
                <Div className="mt-1">
                  <ItemData className="f-12" theme={theme}>
                    <Icon className="fal fa-calendar pl-2" theme={theme}></Icon>
                    {moment(data.created_at, "YYYY-M-D HH:mm:ss").format(
                      "jD jMMMM"
                    )}
                  </ItemData>
                  <ItemData className="mx-3" theme={theme}>
                    |
                  </ItemData>
                  <ItemData className="f-12" theme={theme}>
                    <Icon className="fal fa-clock pl-2" theme={theme}></Icon>
                    {moment(data.created_at, "YYYY-M-D HH:mm:ss").format(
                      "HH:mm"
                    )}
                  </ItemData>
                </Div>
                {data.address ? (
                  <Div>
                    <ItemData className="f-13" theme={theme}>
                      <Icon
                        className="fal fa-map-marker-alt pl-2"
                        theme={theme}
                      ></Icon>
                      <ItemData theme={theme}>
                        {data.address.slice(0, 30)}
                      </ItemData>
                    </ItemData>
                  </Div>
                ) : (
                  <Div>
                    <ItemData className="f-13" theme={theme}>
                      <Icon
                        className="fal fa-map-marker-alt pl-2"
                        theme={theme}
                      ></Icon>
                      <ItemData theme={theme}>تحویل حضوری</ItemData>
                    </ItemData>
                  </Div>
                )}
              </Div>
            </Div>
            <Div className="mt-3">
              <IconLine
                className="fas fa-check-circle mx-2"
                theme={theme}
                {...(data.status >= 1 && { selected: true })}
                {...(data.status === 0 && { selected: true })}
              ></IconLine>
              <BorderLine
                className="d-inline-block vertical-align-super"
                {...(data.status >= 2 && { selected: true })}
                {...(data.status === 0 && { selected: true })}
              />
              <IconLine
                className="fas fa-store mx-2"
                theme={theme}
                {...(data.status >= 2 && { selected: true })}
                {...(data.status === 0 && { selected: true })}
              ></IconLine>
              <BorderLine
                className="d-inline-block vertical-align-super"
                {...(data.status >= 4 && { selected: true })}
                {...(data.status === 0 && { fieled: true })}
              />
              <IconLine
                className="fas fa-shipping-timed mx-2"
                theme={theme}
                {...(data.status >= 4 && { selected: true })}
                {...(data.status === 0 && { fieled: true })}
              ></IconLine>
            </Div>
            {this.state.orderStatus ? (
              <OrderStatus className="mt-2">
                <ChangeStatus data={data} getOrders={this.props.getOrders} />
              </OrderStatus>
            ) : (
              <>
                <Div className="mt-3 mr-2">
                  <Title
                    className="f-12 vertical-align-super d-inline-block"
                    {...(data.status === 0 && { fieled: true })}
                    theme={theme}
                  >
                    {data.status_text}
                  </Title>
                  {this.props?.data?.prepare_at_second ? (
                    <Timer className="f-13 float-left ml-2" theme={theme}>
                      {secondsToTime(this.state.timer).h}:
                      {secondsToTime(this.state.timer).m}:
                      {secondsToTime(this.state.timer).s}
                      <Icon className="fal fa-clock pr-2" theme={theme}></Icon>
                    </Timer>
                  ) : (
                    false
                  )}
                </Div>
              </>
            )}
            <Div className="mt-2">
              <Warning
                className="d-block"
                title="جزییات سفارش"
                onClick={() => orderDetailRef.current.changeStatus()}
              />
            </Div>
          </Card>
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Item);
